import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMutation } from '@features/libs';
import { useContext, useState } from 'react';
import { Logger } from '@ecom-alliance/libs';
import { useMounted, useUpdateEffect } from '@byted/hooks';
import { IMEntranceType } from '@/api/affiliate/data/notification';
import { affiliateNotificationApiClient } from '@/api/affiliate/serv/oec_affiliate_notification_api';
import { AppRuntimeContext } from '@/App';
var useIMQuota = function useIMQuota() {
  var _quotaRule$shop_week_, _quotaRule$shop_week_2, _quotaRule$next_refre, _quotaRule$next_refre2, _quotaRule$gmv_level_, _quotaRule$gmv_level_2;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    creatorIds = _useState2[0],
    setCreatorIds = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    imQuota = _useState4[0],
    setIMQuota = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    quotaRule = _useState6[0],
    setQuotaRule = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    imEntrance = _useState8[0],
    setImEntrance = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    ruleModalVisible = _useState10[0],
    setRuleModalVisible = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    trackParam = _useState12[0],
    setTrackParam = _useState12[1];
  var _useContext = useContext(AppRuntimeContext),
    hasIMQuataPermission = _useContext.platformConfig.hasIMQuataPermission;
  var fetchShopIMQuotaMutation = useMutation(function () {
    return affiliateNotificationApiClient.GetShopIMQuota({}).then(function (imQuotaResp) {
      var _imQuotaResp$quota$ma, _imQuotaResp$quota, _imQuotaResp$quota2, _imQuotaResp$limit_ru;
      var maxQuota = Number((_imQuotaResp$quota$ma = (_imQuotaResp$quota = imQuotaResp.quota) === null || _imQuotaResp$quota === void 0 ? void 0 : _imQuotaResp$quota.max_quota) !== null && _imQuotaResp$quota$ma !== void 0 ? _imQuotaResp$quota$ma : '-1');
      var usedNum = Number((_imQuotaResp$quota2 = imQuotaResp.quota) === null || _imQuotaResp$quota2 === void 0 ? void 0 : _imQuotaResp$quota2.used_num);
      var followerLimit = Number((_imQuotaResp$limit_ru = imQuotaResp.limit_rule) === null || _imQuotaResp$limit_ru === void 0 ? void 0 : _imQuotaResp$limit_ru.reached_max_follower_cnt);
      setIMQuota({
        maxQuota: maxQuota,
        usedNum: usedNum,
        followerLimit: followerLimit,
        restQuota: maxQuota - usedNum >= 0 ? maxQuota - usedNum : 0
      });
      setQuotaRule(imQuotaResp.rule_basic);
    }).catch(function (err) {
      return Logger.info('call api error', err);
    });
  });
  useMounted(function () {
    if (hasIMQuataPermission) {
      fetchShopIMQuotaMutation.mutateAsync();
    }
  });
  var fetchIMEntryMutation = useMutation(function () {
    var filteredCreatorIds = creatorIds.filter(Boolean);
    if (!filteredCreatorIds.length) {
      return Promise.resolve();
    }
    return affiliateNotificationApiClient.CheckShopIMEntrance({
      creator_oec_ids: filteredCreatorIds,
      im_entrance_type: IMEntranceType.CreateConversation
    }).then(function (imEntranceResp) {
      setImEntrance(_objectSpread(_objectSpread({}, imEntrance), imEntranceResp.show_status));
    }).catch(function (err) {
      return Logger.info('[useIMQuota hook fetchIMEntryMutation]call api error', err);
    });
  });
  useUpdateEffect(function () {
    if (hasIMQuataPermission) {
      fetchIMEntryMutation.mutateAsync();
    }
  }, [creatorIds]);
  var openRuleModal = function openRuleModal(param) {
    setRuleModalVisible(true);
    setTrackParam(param);
  };
  var closeRuleModal = function closeRuleModal() {
    setRuleModalVisible(false);
  };
  var refreshIMEntry = function refreshIMEntry() {
    setImEntrance(undefined);
  };
  return {
    setCreatorIds: setCreatorIds,
    refreshIMEntry: refreshIMEntry,
    imQuota: imQuota,
    imEntrance: imEntrance,
    imEntranceLoading: fetchIMEntryMutation.isLoading,
    ruleModal: {
      props: quotaRule ? {
        visible: ruleModalVisible,
        curGMV: (_quotaRule$shop_week_ = (_quotaRule$shop_week_2 = quotaRule.shop_week_gmv) === null || _quotaRule$shop_week_2 === void 0 ? void 0 : _quotaRule$shop_week_2.format_value) !== null && _quotaRule$shop_week_ !== void 0 ? _quotaRule$shop_week_ : '0',
        curLevel: quotaRule.shop_level,
        nextRefreshOffset: (_quotaRule$next_refre = quotaRule.next_refresh_offset) !== null && _quotaRule$next_refre !== void 0 ? _quotaRule$next_refre : '',
        nextRefreshTime: (_quotaRule$next_refre2 = quotaRule.next_refresh_hour) !== null && _quotaRule$next_refre2 !== void 0 ? _quotaRule$next_refre2 : '',
        showFollowSizeCol: Boolean(quotaRule.region_has_follower_limit),
        rule: (_quotaRule$gmv_level_ = (_quotaRule$gmv_level_2 = quotaRule.gmv_level_rule) === null || _quotaRule$gmv_level_2 === void 0 ? void 0 : _quotaRule$gmv_level_2.map(function (x) {
          var _x$left_gmv, _x$right_gmv;
          return _objectSpread(_objectSpread({}, x), {}, {
            left_gmv: (_x$left_gmv = x.left_gmv) === null || _x$left_gmv === void 0 ? void 0 : _x$left_gmv.format_value,
            right_gmv: (_x$right_gmv = x.right_gmv) === null || _x$right_gmv === void 0 ? void 0 : _x$right_gmv.format_value
          });
        })) !== null && _quotaRule$gmv_level_ !== void 0 ? _quotaRule$gmv_level_ : [],
        onCancel: closeRuleModal,
        trackParam: trackParam
      } : null,
      openRuleModal: openRuleModal
    },
    refreshQuota: function refreshQuota() {
      return fetchShopIMQuotaMutation.mutateAsync();
    }
  };
};
export default useIMQuota;